<template>
  <Shipping v-if="shouldShowNewPage" />
  <ShippingLegacy v-if="shouldShowLegacyPage" />
  <RevLoadingScreen
    v-if="!shouldShowNewPage && !shouldShowLegacyPage"
    text=""
  />
</template>

<script setup lang="ts">
import { navigateTo, useRoute, useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import { ROUTE_NAMES } from '~/constants/routes'
import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'
import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import ShippingLegacy from '../ShippingLegacy/ShippingLegacy.vue'

import Shipping from './Shipping.vue'

const sellerInfoStore = useSellerInfoStore()
const { isFeatureEnabled } = useBusinessFeaturesStore()
const route = useRoute()

const shouldShowOldVersion = computed(() =>
  sellerInfoStore.hasAccessToNewShippingPage
    ? false
    : route.query['old-version'] === 'true',
)

const {
  FF_BO_SELLER_IS_NEW_OPTIONS_NEW_SHIPPING_LEGACY_OPEN,
  FF_ENABLE_NEW_SHIPPING_PAGE,
} = useRuntimeConfig().public

const shouldShowNewPage = computed(
  () =>
    !shouldShowOldVersion.value &&
    FF_ENABLE_NEW_SHIPPING_PAGE &&
    (sellerInfoStore.hasAccessToNewShippingPage ||
      isFeatureEnabled('revampedDeliveryMethodsEnabled')),
)
const shouldShowLegacyPage = computed(
  () =>
    !shouldShowNewPage.value &&
    FF_BO_SELLER_IS_NEW_OPTIONS_NEW_SHIPPING_LEGACY_OPEN,
)

if (!shouldShowLegacyPage.value && !shouldShowNewPage.value) {
  navigateTo({ name: ROUTE_NAMES.OPTIONS.SHIPPING })
}
</script>
